import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';

const StyledLink = styled(Link)`
  width: 100%;
  color: #484848;
  text-decoration: none;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
`;

const highlightStyle = {
  color: '#F5415B',
  background: 'transparent',
};

const SearchResultItem = ({
  to,
  searchText,
  resultText,
}) => (
  <MenuItem>
    <StyledLink to={to}>
      <Highlighter
        searchWords={[searchText]}
        textToHighlight={resultText}
        highlightStyle={highlightStyle}
      />
    </StyledLink>
  </MenuItem>
);

SearchResultItem.propTypes = {
  to: PropTypes.string.isRequired,
  searchText: PropTypes.string.isRequired,
  resultText: PropTypes.string.isRequired,
};

export default SearchResultItem;
